import TranslationLang from "components/Translation/TranslationLang";
import React from "react";

// reactstrap components

class WhiteHeader extends React.Component {
  render() {
    return (
      <>
        <div className="header bg-grad pb-4 pt-4 pt-md-4 d-flex justify-content-end align-items-center">
          <TranslationLang />
        </div>
      </>
    );
  }
}

export default WhiteHeader;
